import React, { useEffect, useState, useRef } from "react";
import DataTablePaginationServer from "../../../Components/DataTable/DataTablePaginationServer";
import { ButtonAdd, ButtonEdit } from "../../../Components/Button/Button";
import Loading from "../../../Components/Loading/Loading";
import { useRecoilValue, useRecoilState } from "recoil";
import { userData } from "../../../DataContext/DataContext";
import {
  AlertError,
  AlertSuccess,
  AlertWarning,
} from "../../../Components/AlertDialog/AlertDialog";
import axios from "axios";
import { authorization, UrlApi } from "../../../UrlApi/UrlApi";
import Card from "@mui/material/Card";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import DateRange from "../../../Components/DateRange/DateRange";
import { TextInput } from "../../../Components/Input/Input";
import moment from "moment/moment";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { ButtonOther } from "../../../Components/Button/Button";
import ImgExcell from "../../../Assets/Images/excel.png";
import * as SiIcons from "react-icons/si";
import { DialogTitle } from "@mui/material";
import Btn from "@mui/material/Button";
import RefreshIcon from "@mui/icons-material/Refresh";
import CancelIcon from "@mui/icons-material/Cancel";
import ExportExcel from "../../../Components/ExportExcel/ExportExcel";
import Chip from "@mui/material/Chip";

function ReportsLogUserLogin(props) {
  const [openDialogformEdit, setOpenDialogFormEdit] = useState(false);
  const [openDialogformAdd, setOpenDialogFormAdd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [search, setSearch] = useState("");
  const user = useRecoilValue(userData);
  const [dataExport, setDataExport] = useState([]);
  const refContainer = useRef(null);
  const [date, setDate] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [reportData, setReportData] = useState([]);
  const [documentId, setDocumentId] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [countRowData, setCountRowData] = useState(0);
  const tableRef = useRef();

  const getData = async (page, pageSize, startDate, endDate, search) => {
    const data = {
      page,
      pageSize,
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD"),
    };
    const url =
      UrlApi +
      `get_report_log_user_login?page=${page}
        &page_size=${pageSize}
        &start_date=${moment(startDate).format("YYYY-MM-DD")}
        &end_date=${moment(endDate).format("YYYY-MM-DD")}
        &search=${search}`;
    await axios
      .get(url, authorization)
      .then((res) => {
        if (res.data.length > 0) {
          setCountRowData(res.data[0].count_row_data);
        }else{
          setCountRowData(0);
        }
        setReportData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
      });
  };

  const sendData = async () => {
    const data = {
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD"),
      empId: user.user_id,
    };
    const url = UrlApi + `send_data`;
    setLoading(true);
    await axios
      .post(url, data, authorization)
      .then((res) => {
        if (res.data.status === 1) {
          AlertSuccess(res.data.message);
          setLoading(false);
        } else {
          AlertWarning(res.data.message);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
      });
  };

  useEffect(() => {
    document.addEventListener("keydown", detextKeyDown, true);
    getData(page, pageSize, startDate, endDate, search);
  }, [openDialogformEdit === false, openDialogformAdd === false]);

  const detextKeyDown = (e) => {
    if (e.ctrlKey && e.key === "z") {
      setOpenDialogFormAdd(true);
      return false;
    }
  };

  const columns = [
    {
      title: "ลำดับ",
      field: "list_no",
      filtering: false,
      headerStyle: {
        width: "3rem",
        maxWidth: "3rem",
      },
      cellStyle: { width: "3rem", maxWidth: "3rem" },
    },
    {
      title: "วัน/เวลา",
      field: "savetime",
      headerStyle: {
        width: "5%",
        maxWidth: "5%",
      },
      cellStyle: { width: "5%", maxWidth: "5%" },
    },
    {
      title: "IP Address",
      field: "ip_address",
      headerStyle: {
        width: "5%",
        maxWidth: "5%",
      },
      cellStyle: { width: "5%", maxWidth: "5%" },
    },
    {
      title: "ชื่อพนักงาน",
      field: "emp_name",
      headerStyle: {
        width: "5rem",
        maxWidth: "5rem",
      },
      cellStyle: { width: "5%", maxWidth: "5%" },
    },
    {
      title: "Log การใช้งาน",
      field: "master_usage_name",
      render: (rowData) => {
        let color = "";
        let fontColor = "#FFFFFF";
        switch (parseInt(rowData.master_usage_id)) {
          case 2:
            color = "#F898A4";
            break;
          default:
            color = "#92CEA8";
        }
        return (
          <Chip
            label={rowData.master_usage_name}
            style={{
              background: color,
              color: fontColor,
              fontFamily: "Sarabun",
            }}
          />
        );
      },
      headerStyle: {
        width: "70%",
        maxWidth: "70%",
      },
      cellStyle: { width: "70%", maxWidth: "70%" },
    },
  ];

  const HeaderPage = () => {
    return (
      <>
        <div style={{ paddingTop: "10px" }}>
          <label
            style={{ marginLeft: "10px", marginTop: "10px", fontSize: "18px" }}
          >
            รายงาน Log การใช้งานระบบ
          </label>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
              }}
            >
             {datePicker()}
            </div>
            <div
              style={{
                display: "flex",
              }}
            >
              <div style={{ marginRight: "12px", marginTop: "2px" }}>
                <TextInput
                  width="100%"
                  placeholder="ค้นหา ชื่อพนักงาน"
                  onKeyDown={(e) => {}}
                  value={search}
                  onChange={(e) => {
                    if(e.target.value === ""){
                      setPage(0);
                    }
                    setSearch(e.target.value);
                    getData(page, pageSize, startDate, endDate, e.target.value);                          
                  }}
                  startAdornment={
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  }
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => {
                          setSearch("");
                          setPage(0);
                          getData(0, pageSize, startDate, endDate, "");  
                        }}
                        edge="end"
                      >
                        <CancelIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </div>
              {
                <ButtonOther
                  onClick={() => {
                    exportExcells();
                  }}
                  message="ส่งออก"
                  width="15ch"
                  startIcon={<SiIcons.SiMicrosoftexcel />}
                  
                />
              }
            </div>
          </div>
        </div>
      </>
    );
  };

  
  function datePicker() {
    return (
      <>
        <DateRange
          onClick={(date) => {
            setStartDate(date[0].startDate);
            setEndDate(date[0].endDate);
            getData(page, pageSize, date[0].startDate, date[0].endDate, search);
          }}
        />
      </>
    );
  }

  const exportExcells = async () => {

    const workSheetColumnsName = [
      "ลำดับ",
      "วัน/เวลา",
      "IP Address",
      "ชื่อพนักงาน",
      "Log การใช้งาน",
    ];

    const header = [
      "",
      "รายงานประจำวันที่ " +
        moment(startDate).format("DD/MM/YYYY") +
        " ถึง " +
        moment(endDate).format("DD/MM/YYYY"),
    ];
    
    setLoading(true);
    await axios
      .get(
        UrlApi +
          `get_report_log_user_login?start_date=${moment(startDate).format(
            "YYYY-MM-DD"
          )}&end_date=${moment(endDate).format("YYYY-MM-DD")}
          &page=${page}&page_size=${0}&search=${''}`,
        authorization
      )
      .then((res) => {
        if (res.data.length > 0) {
          const data = res.data.map((item) => {
            return [
              item.list_no,
              item.savetime,
              item.ip_address,
              item.emp_name,
              item.master_usage_name,
            ];
          });
          ExportExcel(
            data,
            workSheetColumnsName,
            "รายงาน Log การใช้งานระบบ",
            "รายงาน Log การใช้งานระบบ.xlsx",
            header,
          );
          setLoading(false);
        } else {
          setLoading(false);
          AlertWarning("ไม่พบข้อมูลที่ต้องการส่งออก");
        }
      })
      .catch((err) => {
        AlertError(err);
      });
  };

  function MaskCharacter(str) {
    let mask = "";
    if (str.length <= 4) {
      mask = str;
    } else {
      let asterisk = "*".repeat(str.length - 4);
      mask = str.replace(/(.{2}).*(.{2})/, "$1" + asterisk + "$2");
    }
    return mask;
    // return ("" + str).slice(0, -n).replace(/./g, mask) + ("" + str).slice(-n);
  }

  return (
    <>
      {/* <label>บันทึกรายละเอียดงานประจำวัน</label> */}
      <Card
        variant="outlined"
        style={{
          paddingLeft: "10px",
          paddingRight: "10px",
          borderRadius: "10px",
        }}
      >
        {HeaderPage()}
        <DataTablePaginationServer
          tableRef={tableRef}
          exportButton={true}
          columns={columns}
          data={reportData}
          page={page}
          totalCount={countRowData}
          width="100%"
          onChangePage={(event, newPage) => {
            setPage(newPage);
            getData(newPage, pageSize, startDate, endDate, search);
          }}
          onChangeRowsPerPage={(e) => {
            setPageSize(e.target.value);
            getData(page, e.target.value, startDate, endDate, search);
          }}
          pageSize={pageSize}
        />
      </Card>
      <Loading open={loading} />
    </>
  );
}

export default ReportsLogUserLogin;
